module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_sand_6-9afa903527b681c87a5a1b8ef4554e54.webp";